import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { fromEvent as observableFromEvent, of, startWith, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { SupportedThemesT, ThemeName } from '@core/theme-util';

@Injectable({ providedIn: 'root' })
export class ThemeUtilsService {
  public static themeFromMatchMedia$: Observable<SupportedThemesT> =
    typeof window !== 'undefined'
      ? observableFromEvent(window.matchMedia('(prefers-color-scheme: dark)'), 'change').pipe(
          startWith(window.matchMedia('(prefers-color-scheme: dark)')),
          map((event: MediaQueryList) => (event.matches ? 'dark' : 'light')),
        )
      : of('light');

  public static findEffectiveThemeNameFromPreferences = (
    source: Observable<{
      preferences: { theme: ThemeName; pipelinePromoteBannerDismissedOfferIds: number[] };
    }>,
  ) =>
    source.pipe(
      switchMap(
        data =>
          <Observable<SupportedThemesT>>(
            (data.preferences.theme === 'auto'
              ? ThemeUtilsService.themeFromMatchMedia$
              : of(data.preferences.theme))
          ),
      ),
    );

  public static findEffectiveThemeName = (theme: ThemeName) =>
    theme === 'auto' ? ThemeUtilsService.themeFromMatchMedia$ : of(theme);

  public static setThemeHTMLData(theme: SupportedThemesT): void {
    if (typeof document === 'undefined') return;

    document.documentElement.setAttribute('data-theme', theme);
  }
}
